import React from "react";
import { logAppError } from "../utils/errorHandler";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logAppError(error, {
      source: "ErrorBoundary",
      action: "render_crash",
      metadata: {
        componentStack: errorInfo?.componentStack || "",
      },
    });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f8f9fa",
            padding: "24px",
          }}
        >
          <div
            style={{
              maxWidth: "560px",
              width: "100%",
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
              padding: "24px",
            }}
          >
            <h2 style={{ marginBottom: "12px" }}>Something went wrong</h2>
            <p style={{ marginBottom: "16px", color: "#495057" }}>
              We could not render this screen. Please try again.
            </p>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.handleRetry}
              >
                Try again
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => window.location.reload()}
              >
                Reload page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
